import React from 'react';
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink';
import Button from 'src/viewLayer/components/shared/Button';

// to avoid *inProgress* to be passed to TrackableLink
// and causing [`Unknown Prop Warning`](https://reactjs.org/warnings/unknown-prop.html)
// we extract it from props and pass it explicitly
export default ({
  children,
  inProgress,
  ...props
}) => (
  <TrackableLink {...props}>
    <Button inProgress={inProgress} {...props}>
      { children }
    </Button>
  </TrackableLink>
);
